import { CanalDistribuicao, CanalDistribuicaoActions, CanalDistribuicaoState, intialValueCanalDistribuicao } from "../canalDist.model"
import ViewCad from "../../../view";
import { useCallback, useEffect, useState } from "react";
import { DespesaCanalDistribuicao, EstoqueCanalDistriuicao, Item } from "../../../data.types";
import { GridColDef } from "@mui/x-data-grid";
import { formatMoney, getNewId, isEmpty } from "../../../services/utils";
import { funcionarioController } from "../../funcionario/funcionario.controll";
import { Box } from "@mui/material";
import { handleShowSelectItemModal, ViewItemSelectModal } from "../../item/view/item.select";


interface CanalDistribuicaoViewProps {
    canalDistribuicaoState: CanalDistribuicaoState
    canalDistribuicaoActions: CanalDistribuicaoActions
}


interface CanalDistribuicaoCadProps extends CanalDistribuicaoViewProps {
    handleCloseView: (row?: CanalDistribuicao) => any
}


export function CanalDistribuicaoCadastro(props: CanalDistribuicaoCadProps) {
    const { canalDistribuicaoActions, canalDistribuicaoState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = canalDistribuicaoState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir } = canalDistribuicaoActions


    const handleExcluir = (state: CanalDistribuicaoState) => {
        deletar(state.row);
        setShowDialogExluir(false);
        handleCloseView()
    }

    const formValidate = (state: CanalDistribuicaoState) => {
        const errors: any = { row: { funcionario: {} } }
        console.log("formValidate", state)
        if (!state.row.funcionario._id)
            errors.row.funcionario.nome = "Informe o funcionário"
        return errors
    }

    const handleUpdate = (state: CanalDistribuicaoState) => {
        if (!state.row._rev) {
            create(state.row);
        } else {
            update(state.row);
        }
    }

    const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
        changeValue(state, field, () => value)
    }

    const handleNovoEstoque = (values?: CanalDistribuicaoState, mutator?: (value: any, field: any) => any) => {
        mutator && mutator(true, "showModalEstoque")
    }

    const handleNovaDespesa = (values?: CanalDistribuicaoState, mutator?: (value: any, field: any) => any) => {
        mutator && mutator(true, "showModalDespesa")
    }


    var viewCad = new ViewCad({
        formTitle: "Cadastro do CanalDistribuicao",
        formFieldDescription: "row.funcionario.nome",
        loading: loading,
        msg: msg,
        row: canalDistribuicaoState,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: false,
            title: "",
            onClick: () => {},
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        handleMutator: handleMutator,
        contentForm: [
            {
                fieldName: "row.funcionario", label: "Funcionario", type: "autocomplete", labelAutocomplete: "nome",
                colunsXS: 12, colunsSM: 12, colunsMD: 12, require: true,
                list: funcionarioController.state.rows,
                disabled:!isEmpty(row._rev)
            },
            { fieldName: "row.data", label: "Data", type: "data", key: "data", colunsXS: 12, colunsSM: 6, colunsMD: 6, require: true,disabled:!isEmpty(row._rev)},
            { fieldName: "row.situacao", label: "Situação do Canal", type: "chip", key: "situacao", colunsXS: 12, colunsSM: 6, colunsMD: 6 },
            {
                fieldName: "row.estoque_dist", label: "Estoque", type: "list", key: "estoque_dist", colunsXS: 12, colunsSM: 12, colunsMD: 12, columns: columnsEstoque,
                fieldList: { fieldPrimary: "item.descricao", fieldSecondary: "qt", fieldSecondaryEnd: "_id" },
                tip: "Adicionar estoque.",
                handleOnClickShow: handleNovoEstoque,
                handleOnClickUpdade: (value,mutator)=>{{
                    console.log("handleOnClickUpdade",value,mutator)
                    if(mutator){
                        mutator(value,"valueEstoque")
                        mutator(true,"showModalEstoque")
                    }

                }}

            },
            {
                fieldName: "row.despesas", label: "Despesas", type: "list", key: "despesas", colunsXS: 12, colunsSM: 12, colunsMD: 12, columns: columnsDespesas,
                fieldList: { fieldPrimary: "descricao", fieldSecondary: "valor", fieldSecondaryEnd: "_id" },
                tip: "Adicionar despesas",
                handleOnClickShow: handleNovaDespesa,
                handleOnClickUpdade: (value,mutator)=>{{
                    console.log("handleOnClickUpdade",value,mutator)
                    if(mutator){
                        mutator(value,"valueDespesa")
                        mutator(true,"showModalDespesa")
                    }
                }}
            },
        ],
        ContentBox: (props) => {
            console.log("values form", props)
            var canalDist = props!.values.row;
            var values = props!.values
            const handleRemoveEstoque = (value: EstoqueCanalDistriuicao) => {
                console.log("remover ", value);
                let canal: CanalDistribuicao = structuredClone(canalDist);
                let idx = canal.estoque_dist.findIndex(row => row._id === value._id)
                canal.estoque_dist.splice(idx, 1);
                props?.form.mutators.handleMutator(canal.estoque_dist, "row.estoque_dist")
            }

            const clearValueEstoque = () => {
                props?.form.mutators.handleMutator({ _id: "", item: {} as Item, qt: 0 }, "valueEstoque")
            }

            const handleAddEstoque = (value: EstoqueCanalDistriuicao) => {
                let canal: CanalDistribuicao = structuredClone(canalDist);
                console.log("chamou handleupdade estoque", [canal, value])
                if (value._id) {//atualizar
                    let idx = canal.estoque_dist.findIndex(row => row._id === value._id)
                    canal.estoque_dist[idx] = value;
                } else {//adicionar
                    value._id = getNewId();
                    canal.estoque_dist.push(value);
                    props?.form.mutators.handleMutator(canal.estoque_dist, "row.estoque_dist")
                }
            }

            const handleAddDespesa = (value: DespesaCanalDistribuicao) => {
                let canal: CanalDistribuicao = structuredClone(canalDist);
                console.log("chamou handleupdade despesa", [canal, value])
                if (value._id) {//atualizar
                    let idx = canal.despesas.findIndex(row => row._id === value._id)
                    canal.despesas[idx] = value;
                } else {//adicionar
                    value._id = getNewId();
                    canal.despesas.push(value);
                    props?.form.mutators.handleMutator(canal.despesas, "row.despesas")
                }
            }

            const handleRemoveDespesa = (value: DespesaCanalDistribuicao) => {
                console.log("remover ", value);
                let canal: CanalDistribuicao = structuredClone(canalDist);
                let idx = canal.despesas.findIndex(row => row._id === value._id)
                canal.despesas.splice(idx, 1);
                props?.form.mutators.handleMutator(canal.despesas, "row.despesas")
                
            }

            const clearValueDespesa = () => {
                props?.form.mutators.handleMutator({ _id: "", descricao: "", valor: 0 }, "valueDespesa")
            }

            return (
                <Box>
                    {
                        CadEstoque({
                            addNew: handleAddEstoque,
                            value:values.valueEstoque,
                            handleClose: () => {
                                props?.form.mutators.handleMutator(
                                    false, "showModalEstoque"
                                )
                                clearValueEstoque()
                            },
                            handleExcluir:handleRemoveEstoque
                        }).renderModal({
                            handleClose: () => {
                                props?.form.mutators.handleMutator(
                                    false, "showModalEstoque"
                                )
                                clearValueEstoque()
                            },
                            show: values.showModalEstoque,
                            heigth: "auto",
                            width: "sm"
                        })
                    }

                    {
                        CadDespesa({
                            addNew: handleAddDespesa,
                            value:values.valueDespesa,
                            handleClose: () => {
                                props?.form.mutators.handleMutator(
                                    false, "showModalDespesa"
                                )
                                clearValueDespesa()
                            },
                            handleRemove:handleRemoveDespesa
                        }).renderModal({
                            handleClose: () => {
                                props?.form.mutators.handleMutator(
                                    false, "showModalDespesa"
                                )
                                clearValueDespesa()
                            },
                            show: values.showModalDespesa,
                            heigth: "auto",
                            width: "sm"
                        })
                    }
                </Box>
            )
        }
    })

    return viewCad
}


const columnsEstoque: GridColDef[] = [
    { field: 'item.descricao', headerName: 'Item', flex: 7, valueGetter: (value, row) => row.item.descricao },
    { field: 'qt', headerName: 'Quantidade', flex: 5 },
]

interface CadEstoqueProps {
    addNew: (row: EstoqueCanalDistriuicao) => any
    handleClose: () => any
    handleExcluir:(value:EstoqueCanalDistriuicao) => any
    value:EstoqueCanalDistriuicao
}

function CadEstoque(props: CadEstoqueProps) {
    const { handleClose, addNew,handleExcluir } = props
    const [showDialogExluir, setShowDialogExluir] = useState(false);
    const [row, setRow] = useState(props.value)

    useEffect(()=>{
        setRow(props.value)
    },[props.value])

    const formValidate = (values: EstoqueCanalDistriuicao) => {
        const errors: any = { item: {} }
        if (!values.item._id)
            errors.item.descricao = "Informe o item"
        return errors
    }

    const handleUpdate = (value: EstoqueCanalDistriuicao) => {
        addNew(value);
    }

    const excluir = (value:any) => {
        handleExcluir(value);
        setShowDialogExluir(false);
        handleClose()
    }


    const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
        changeValue(state, field, () => value)
    }

    var viewCadEstoque = new ViewCad({
        formTitle: "Adicionar estoque ",
        formFieldDescription: "item.descricao",
        loading: false,
        msg: "",
        row: row,
        status: "",
        showAlert: false,
        showDialogExluir:showDialogExluir,
        buttonNovo: {
            show: true,
            title: "",
            onClick: () => setRow({ _id: "", item: {} as Item, qt: 0 }),
        },
        handleExcluir: excluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => { },
        setShowDialogExluir:setShowDialogExluir,

        handleCloseView: handleClose,
        handleMutator: handleMutator,

        contentForm: [
            {
                fieldName: "item.descricao", label: "item", type: "select-dialog", key: "item",
                colunsXS: 8, colunsSM: 8, colunsMD: 8, require: true,
                handleOnClickShow: () => handleShowSelectItemModal(true),
                ViewSelecionarDialog: (props) =>
                    <ViewItemSelectModal
                        needTabPreco={false}
                        handleItemSelect={(value) => {
                            console.log("props ", props);
                            console.log("item", value.item)
                            props.handleMutator(value.item, "item")
                            handleShowSelectItemModal(false)
                        }}
                    />
            },
            { fieldName: "qt", label: "Quantidade", type: "text", key: "numero", colunsXS: 2, colunsSM: 2, colunsMD: 2, require: false },
        ],

    })

    return viewCadEstoque
}

const columnsDespesas: GridColDef[] = [
    { field: 'descricao', headerName: 'Descrição', flex: 8 },
    { field: 'valor', headerName: 'Valor', flex: 4, valueFormatter: (value, row) => formatMoney(value) },
]


interface CadDespesaProps {
    addNew: (row: DespesaCanalDistribuicao) => any
    handleClose: () => any
    value:DespesaCanalDistribuicao
    handleRemove:(value:DespesaCanalDistribuicao) => any
}

function CadDespesa(props: CadDespesaProps) {
    const { handleClose, addNew, handleRemove } = props
    const [showDialogExluir, setShowDialogExluir] = useState(false);
    const [row, setRow] = useState(props.value)
  
    useEffect(()=>{
        setRow(props.value)
    },[props.value])  
  
    const formValidate = (values: DespesaCanalDistribuicao) => {
        const errors: any = { item: {} }
        if (!values.descricao)
            errors.descricao = "Informe a descrição da despesa"
        return errors
    }


    const handleUpdate = (value: DespesaCanalDistribuicao) => {
        addNew(value);
    }

    const handleExcluir = (value:any) => {
        handleRemove(value);
        setShowDialogExluir(false);
        handleClose()
    }

    const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
        changeValue(state, field, () => value)
    }

    var viewCadDespesa = new ViewCad({
        formTitle: "Adicionar despesa ",
        formFieldDescription: "descricao",
        loading: false,
        msg: "",
        row: row,
        status: "",
        showAlert: false,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "",
            onClick: () => setRow({ _id: "", descricao: "", valor: 0 }),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => { },
        setShowDialogExluir:setShowDialogExluir,
        handleCloseView: handleClose,
        handleMutator: handleMutator,

        contentForm: [
            {
                fieldName: "descricao", label: "Descrição", type: "text", key: "descricao",
                colunsXS: 8, colunsSM: 8, colunsMD: 8, require: true,
            },
            { fieldName: "valor", label: "Valor", type: "currency", key: "valor", colunsXS: 2, colunsSM: 2, colunsMD: 2, require: false },
        ],

    })

    return viewCadDespesa
}
